export const EXPAND_ARROW_WIDTH = 28
export const PARTNER_CATEGORY_EMPTY_WIDTH = 90

const widths = {
  country: 100,
  advertiser: 100,
  product: 100,
  partner: 175,
  partner_tag: 75,
  partner_category: 105,
  offer: 200,
  traffic_source: 100,
  stream: 200,
  affiliate_id: 100,
  landing: 200,
  actual_country: 100,
  site_id_sub_id: 100,
  site_id: 75,
  sub_id: 100,
  sub_ids_header: 100,
  date: 100,
  week: 200,
  month: 100,
  partner_group: 150,
  main_manager: 150,
  payment_model: 75,
  offer_category: 75,
  promocode: 100,
  click_id: 150,
  segment: 150,
}

export default new Proxy(widths, {
  get(target, key) {
    if (key in target) return target[key]
    if (typeof key === 'string' && /^sub_[1-9]$/.test(key)) return target.sub_ids_header
  },
})
